/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable jsdoc/require-jsdoc */
import { PriorityList, SimplifiedParameterWidget } from '../constants/telosair-interfaces';
import useStorageState from '../hooks/useStorageState';
import { Filters } from '../services/localstorage.service';
import { STALE_TEXT_CLASS, lastReportedLabel } from '../_helpers/staleData';
import { formatCardNumber } from '../_helpers/globalHelper';

interface ParameterWidgetProps {
  parameters: SimplifiedParameterWidget[];
}

export default function ParameterWidget({ parameters }: ParameterWidgetProps) {
  const [currentIndex, setCurrentIndex] = useStorageState(Filters.parameterWidgetIndex, 0);
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % parameters.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + parameters.length) % parameters.length);
  };

  const getStatusColor = (status: SimplifiedParameterWidget['status']) => {
    switch (status) {
      case PriorityList.high:
        return 'text-error-500';
      case PriorityList.medium:
        return 'text-warning-500';
      case PriorityList.low:
        return 'text-success-500';
      default:
        return 'text-white';
    }
  };

  // const renderIcon = (status: SimplifiedParameterWidget['status']) => {
  //   switch (status) {
  //     case PriorityList.low:
  //       return <span className="material-icons mr-2 text-success-500">check_circle</span>;
  //     case PriorityList.medium:
  //       return <span className="material-icons mr-2 text-warning-500">warning</span>;
  //     case PriorityList.high:
  //     case PriorityList.critical:
  //       return <span className="material-icons mr-2 text-error-500">error</span>;
  //     default:
  //       return null;
  //   }
  // };

  const currentParameter = parameters?.length > 1 ? parameters?.[currentIndex] : parameters?.[0];

  const renderCarousel = () => {
    const currentValue = currentParameter?.value;
    const displayValue =
      typeof currentValue === 'number' ? formatCardNumber(currentValue) : currentValue ?? '-';
    // Nothing reported in the window: the last known value is shown in grey.
    const isStale = currentParameter?.stale === true && displayValue !== '-';
    const valueClass = isStale ? STALE_TEXT_CLASS : getStatusColor(currentParameter?.status);

    return (
      <div className="relative flex flex-col items-center gap-6 justify-between p-4 rounded-lg bg-background-700 text-white">
        <h3 className="text-lg font-semibold text-gray-400">{currentParameter?.label || '-'}</h3>
        <div
          style={{ justifyContent: parameters?.length > 1 ? 'space-between' : 'center' }}
          className="flex items-center w-full"
        >
          {parameters?.length > 1 && (
            <button type="button" onClick={handlePrev} className="text-gray-400 hover:text-white">
              <span className="material-icons">chevron_left</span>
            </button>
          )}
          <div
            className={`text-6xl font-bold ${valueClass}`}
            title={isStale ? lastReportedLabel(currentParameter?.asOf) : undefined}
          >
            {displayValue}
          </div>
          {parameters?.length > 1 && (
            <button type="button" onClick={handleNext} className="text-gray-400 hover:text-white">
              <span className="material-icons">chevron_right</span>
            </button>
          )}
        </div>
        <div className="text-md text-white -mt-2 flex flex-col items-center gap-0.5">
          <span className="text-sm text-gray-400">{currentParameter?.unit}</span>
          {isStale && (
            <span className={`text-xs ${STALE_TEXT_CLASS}`}>
              {lastReportedLabel(currentParameter?.asOf)}
            </span>
          )}
        </div>
      </div>
    );
  };

  return renderCarousel();
}
